import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionService } from '../services/session.service';

/**
 * Keeps local (file-portal) accounts off the gateways page — the mirror of
 * localAccountGuard.
 *
 * The legacy site never showed them gateways: usr/main.php had a Files link
 * where usr/main_gw.php had Gateways, so reaching it by URL is not something we
 * want to allow either.
 *
 * Admins are let through even though they are local accounts themselves: the
 * gateways page doubles as their admin table, and the login flow already sends
 * them there (see AuthModalComponent — only a local NON-admin lands on
 * /my-files).
 */
export const cloudAccountGuard: CanActivateFn = () => {
    const session = inject(SessionService);
    const router = inject(Router);

    if (!session.isLoggedIn()) {
        router.navigate(['/']);
        return false;
    }
    if (session.isLocal() && !session.isAdmin()) {
        router.navigate(['/my-files']);
        return false;
    }
    return true;
};
